import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = { style: {"margin-bottom":"20px","max-height":"120px","overflow":"auto"} }
const _hoisted_7 = {
  key: 0,
  class: "checkbox-input"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  style: {"margin-bottom":"20px"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onUpdate:modelValue", "onInput"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onUpdate:modelValue", "onInput"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["onUpdate:modelValue", "onChange"]
const _hoisted_22 = { key: 3 }
const _hoisted_23 = ["onUpdate:modelValue", "onChange"]
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 4,
  style: {"margin-bottom":"20px"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 6,
  class: "checkbox-input",
  style: {"margin-top":"15px"}
}
const _hoisted_28 = {
  class: "checkbox-input",
  style: {"margin-top":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_info_tip = _resolveComponent("info-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _createElementVNode("div", null, [
            _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Status) = $event))
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("option", { value: "Active" }, "Active", -1),
              _createElementVNode("option", { value: "Terminated" }, "Terminated", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.formData.Status]
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("h3", null, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.Name) = $event)),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fieldChange('Name')))
            }, null, 544), [
              [_vModelText, _ctx.formData.Name]
            ]),
            (_ctx.formData.Status == 'Terminated')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[19] || (_cache[19] = _createElementVNode("h3", { style: {"color":"red"} }, "Termination Details", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.TerminationDetails) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.formData.TerminationDetails]
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { style: {"color":"red"} }, "Termination Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.TerminationDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.formData.TerminationDate]
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.Email) = $event)),
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fieldChange('Email')))
            }, null, 544), [
              [_vModelText, _ctx.formData.Email]
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Phone", -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.formData.Phone,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.Phone) = $event)),
                _cache[9] || (_cache[9] = ($event: any) => (_ctx.fieldChange('Phone')))
              ]
            }, null, 8, ["modelValue"]),
            _cache[29] || (_cache[29] = _createElementVNode("h3", null, "Team", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.Team) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeTeams, (t, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: t
                }, _toDisplayString(t), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formData.Team]
            ]),
            (_ctx.employeeTeams.length > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("h3", null, [
                    _cache[21] || (_cache[21] = _createTextVNode("Additional Teams", -1)),
                    _createVNode(_component_info_tip, { text: "Adding additional teams gives this employee access to those teams' scoreboards, the same as their primary team: they can see and update the team's scorecard and rocks metrics." })
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeTeams, (t, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                        (t != _ctx.formData.Team)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: t,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.AdditionalTeams) = $event))
                              }, null, 8, _hoisted_8), [
                                [_vModelCheckbox, _ctx.formData.AdditionalTeams]
                              ]),
                              _createElementVNode("div", null, _toDisplayString(t), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.$store.state.user.isAdmin)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_9, "Location"))
              : _createCommentVNode("", true),
            (_ctx.$store.state.user.isAdmin)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 3,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.Location) = $event)),
                  onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.fieldChange('Location')))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (l, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: l
                    }, _toDisplayString(l), 9, _hoisted_10))
                  }), 128))
                ], 544)), [
                  [_vModelSelect, _ctx.formData.Location]
                ])
              : _createCommentVNode("", true),
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? (_openBlock(), _createElementBlock("h3", _hoisted_11, "Reporting To"))
              : _createCommentVNode("", true),
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 5,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.ReportingTo) = $event))
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("option", { value: null }, "No One", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managerEmployees, (e, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: e.ID
                    }, _toDisplayString(e.Name), 9, _hoisted_12))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, _ctx.formData.ReportingTo]
                ])
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.AdditionalFieldsJSON, (f, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                (f.secure && !f.updating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("a", {
                        onClick: () => { f.oldValue = f.value; f.value = ''; f.updating = true; }
                      }, "Update", 8, _hoisted_14)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (f.type == 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((f.value) = $event),
                              onInput: ($event: any) => (_ctx.fieldChange(f.name))
                            }, null, 40, _hoisted_17), [
                              [_vModelText, f.value]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (f.type == 'multitext')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((f.value) = $event),
                              onInput: ($event: any) => (_ctx.fieldChange(f.name))
                            }, null, 40, _hoisted_19), [
                              [_vModelText, f.value]
                            ])
                          ]))
                        : (f.type == 'date')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": ($event: any) => ((f.value) = $event),
                                onChange: ($event: any) => (_ctx.fieldChange(f.name))
                              }, null, 40, _hoisted_21), [
                                [_vModelText, f.value]
                              ])
                            ]))
                          : (f.type == 'select')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((f.value) = $event),
                                  onChange: ($event: any) => (_ctx.fieldChange(f.name))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.options, (op, j) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: 'o'+j,
                                      value: op
                                    }, _toDisplayString(op), 9, _hoisted_24))
                                  }), 128))
                                ], 40, _hoisted_23), [
                                  [_vModelSelect, f.value]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                      (f.secure)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("a", {
                              onClick: () => { f.value = f.oldValue; f.updating = false; }
                            }, "Cancel Update", 8, _hoisted_26)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            }), 128)),
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.IsManager) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.formData.IsManager]
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("h3", null, "Is Manager?", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.sendEmail) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.formData.sendEmail]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("h3", null, "Send Admin Email?", -1))
            ]),
            _createElementVNode("input", {
              style: {"margin-top":"15px"},
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submit()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}